export const CART_API_RESPONSE_SUCCESS = "CART_API_RESPONSE_SUCCESS";
export const CART_API_RESPONSE_FAIL = "CART_API_RESPONSE_FAIL";
export const GET_CART = "GET_CART";
export const ADD_TO_CART = "ADD_TO_CART";
export const UPDATE_QUANTITY = "UPDATE_QUANTITY";
export const REMOVE_ITEM = "REMOVE_ITEM";
